<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Subscribe to newsletter' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <iframe class="w-100 border-0 newsletter-iframe" src="https://cdn.forms-content-1.sg-form.com/610f47dc-edc9-11ee-8c07-0ac52132fa1c"></iframe>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-outline-secondary ml-auto mr-0" (click)="activeModal.close(false)">{{'Close' | translate}}</button>
    </div>
  </div>
</div>

